import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.scss']
})
export class BottomBarComponent implements OnInit {

    constructor(private router: Router,
        private storageService: StorageService) { }

    hasRoadMap: boolean = true;
    isLoggedIn: boolean = false;
    ngOnInit() {

        this.isLoggedIn = this.storageService.getItem("token") != undefined;

        let component = this.router.routerState.snapshot.url.split('/');
        if (component.length > 2 && component[2].toLocaleUpperCase().includes("LOGIN") ||
            component.length > 2 && component[2].toLocaleUpperCase().includes("LOGOUT")) {
            this.hasRoadMap = false;
        }


  }

}
